import SponsorFieldsContainer from './SponsorFieldsContainer';
import { ReactElement } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import SiteAdminCheck from 'pages/NewNonEmployee/components/fields/SiteAdminCheck';

/**
 * Form container for initial set of questions to ask when creating a user type with a site admin option
 * @param {string} label display text for site-admin-check component and self-sponsor component
 * @param {ReactElement[]} additionalFields extra questions to ask on the form
 * @returns {ReactElement} form inputs for site administrator and sponsor questions
 */
const InitializationStep = ({ label, additionalFields = [] }) => {
	<SponsorFieldsContainer label={label} />;
	return (
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<SiteAdminCheck labelUsernameType={label} />
			</Grid>
			{additionalFields.map((additionalField, index) => (
				<Grid key={'additionalField-' + index} item xs={12}>
					{additionalField}
				</Grid>
			))}
		</Grid>
	);
};

InitializationStep.propTypes = {
	label: PropTypes.string.isRequired,
};

export default InitializationStep;
